"use client"

import { Component } from "react"
import moment from "moment"
import * as XLSX from "xlsx"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import Toast from "../../components/Toast"
import Button from "@mui/material/Button"
import routes from "../../routes/URL"
import assets from "../../common/assets"


const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class UserListViewScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      orderData: null,
      currentUser: null,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
      return;
    }
    const locationState = this.props.location?.state

    if (locationState && locationState.orderData && locationState.modalData) {
      this.setState({
        orderData: locationState.orderData,
        currentUser: locationState.modalData,
        loading: false,
      })
    } else {
      this.props.history.push(routes.admin.settings.allusers)
    }
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  goBack = () => {
    this.props.history.push(routes.admin.settings.allusers)
  }

  exportCurrentUserOrders = () => {
    const { orderData, currentUser } = this.state

    if (!orderData || !orderData.data || orderData.data.length === 0) {
      this.showToast("No order data to export", "warning")
      return
    }

    const customerInfo = [
      ["Customer Details", ""],
      ["Name", currentUser.user_name],
      ["Email", currentUser.user_email],
      ["Phone", currentUser.user_phone],
      ["Total Orders", orderData.data.length],
      ["", ""],
      ["Order History", ""],
    ]

    const orderHeaders = [
      "Order ID",
      "Date",
      "Type",
      "Status",
      "Payment Method",
      "Total Amount (₹)",
      "Discount (₹)",
      "Tax (₹)",
      "Subtotal (₹)",
    ]

    const orderRows = orderData.data.map((order) => [
      order.id,
      moment(order.order_date_time).format("DD-MM-YYYY HH:mm"),
      order.order_type,
      order.order_status,
      order.payment_method || "N/A",
      Number.parseFloat(order.order_grand_total).toFixed(2),
      Number.parseFloat(order.discount || 0).toFixed(2),
      Number.parseFloat(order.tax || 0).toFixed(2),
      Number.parseFloat(order.subtotal || 0).toFixed(2),
    ])

    const totalAmount = orderData.data.reduce((sum, order) => sum + Number(order.order_grand_total), 0)
    const summaryRow = ["TOTAL", "", "", "", "", totalAmount.toFixed(2), "", "", ""]
    const exportData = [...customerInfo, orderHeaders, ...orderRows, summaryRow]
    const ws = XLSX.utils.aoa_to_sheet(exportData)
    const csv = XLSX.utils.sheet_to_csv(ws, { FS: ",", RS: "\n" })
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const fileName = `${currentUser.user_name.replace(/\s+/g, "_")}_Orders_${moment().format("YYYYMMDD")}.csv`

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      const link = document.createElement("a")
      const url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    this.showToast("Order history exported as CSV successfully", "success")
  }

  render() {
    const { orderData, currentUser, toast, loading } = this.state

    if (loading) {
      return (
        <div style={{ backgroundColor: ColorScheme.bgColor, minHeight: "100vh", padding: "2rem" }}>
          <Header title="Customer Details" />
          <div style={{ textAlign: "center", padding: "50px" }}>
            <p>Loading...</p>
          </div>
        </div>
      )
    }

    if (!currentUser) {
      return (
        <div style={{ backgroundColor: ColorScheme.bgColor, minHeight: "100vh", padding: "2rem" }}>
          <Header title="Customer Details" />
          <div style={{ textAlign: "center", padding: "50px" }}>
            <p>No customer data found</p>
            <Button
              onClick={this.goBack}
              variant="contained"
              sx={{
                backgroundColor: ColorScheme.buttonColor,
                color: ColorScheme.componentColor,
                '&:hover': {
                  backgroundColor: '#E6B54E'
                }
              }}
            >
              Go Back to Customer List
            </Button>
          </div>
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: ColorScheme.bgColor, minHeight: "100vh", padding: "2rem", width: "-webkit-fill-available", }}>
        <Header title="Customer Order History" />

        {/* Customer Info */}
        <div
          style={{
            // backgroundColor: ColorScheme.componentColor,
            padding: "20px",
            borderRadius: "8px",
            marginBottom: "20px",
            color: ColorScheme.textColor,
          }}
        >

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            {currentUser.user_name && (
              <div>
                <strong>Name:</strong> {currentUser.user_name}
              </div>
            )}
            {currentUser.user_email && (
              <div>
                <strong>Email:</strong> {currentUser.user_email}
              </div>
            )}
            {currentUser.user_phone && (
              <div>
                <strong>Phone:</strong> {currentUser.user_phone}
              </div>
            )}
            <div>
              <strong>Total Orders:</strong> {orderData?.data?.length || 0}
            </div>
          </div>

        </div>

        {/* Order History Section */}
        <div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
          
            {/* {orderData?.data?.length > 0 && (
              <Button
                variant="contained"
                onClick={this.exportCurrentUserOrders}
                sx={{
                  px: 4,
                  py: 1,
                  borderRadius: 1,
                  textTransform: "none",
                  fontWeight: 700,
                  backgroundColor: ColorScheme.buttonColor,
                  color: ColorScheme.componentColor,
                  '&:hover': {
                    backgroundColor: '#E6B54E'
                  }
                }}
              >
                Export to Excel
              </Button>
            )}
          </div> */}

          {orderData?.data?.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table className="table" style={{ width: "100%", color: ColorScheme.textColor }}>
                <thead>
                  <tr>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Order ID</span>
                      </div>
                    </th>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Date</span>
                      </div>
                    </th>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Type</span>
                      </div>
                    </th>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Status</span>
                      </div>
                    </th>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Payment</span>
                      </div>
                    </th>
                    <th style={{ borderBottom: `1px solid ${ColorScheme.buttonColor}`, padding: "1rem" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Total</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orderData.data.map((order, index) => (
                    <tr
                      key={order.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "transparent" : "#041A29",
                        borderBottom: "none",
                      }}
                    >
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        {order.id}
                      </td>
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        {moment(order.order_date_time).format("DD-MM-YYYY HH:mm")}
                      </td>
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        <div className="d-flex align-items-center h-100">
                          <span
                            style={{
                              backgroundColor: order.order_type === "dinein" ? "#691727" : "#453E2A",
                              color: "white",
                              padding: "6px 10px",
                              borderRadius: "16px",
                              fontSize: "12px",
                              fontWeight: "bold",
                              display: "inline-flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "4px",
                              minWidth: "120px",
                              boxSizing: "border-box",
                            }}
                          >
                            {order.order_type === "dinein" ? (
                              <>
                                <img
                                  src={assets.dineinIcon}
                                  alt="Dine In"
                                  style={{ width: "14px", height: "14px" }}
                                />
                                Dine In
                              </>
                            ) : (
                              <>
                                <img
                                  src={assets.pickupIcon}
                                  alt="Take Away"
                                  style={{ width: "14px", height: "14px" }}
                                />
                                Take Away
                              </>
                            )}
                          </span>
                        </div>
                      </td>
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        <div className="d-flex align-items-center h-100">
                          <span
                            style={{
                              backgroundColor: order.order_status === "completed" ? "#00A651" : "#BB0A21",
                              color: "white",
                              padding: "6px 10px",
                              borderRadius: "16px",
                              fontSize: "12px",
                              fontWeight: "bold",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center", // This centers the text horizontally
                              gap: "4px",
                              minWidth: "110px",
                              boxSizing: "border-box",
                            }}
                          >
                            {order.order_status}
                          </span>
                        </div>
                      </td>
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        {order.payment_method || "N/A"}
                      </td>
                      <td style={{ padding: "1rem", border: "none", verticalAlign: "middle" }}>
                        ₹{Number.parseFloat(order.order_grand_total).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#041A29",
                color: ColorScheme.textColor,
              }}
            >
              <p>No orders found for this customer.</p>
            </div>
          )}
        </div>

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(UserListViewScreen)